import React from 'react'
import { ForEachModel } from '@morningtrain/react-resources'
import InventoryOrderItemFields from 'widgets/inventory/InventoryOrderItemFields'
import { Table } from 'widgets/crud'
import DraftOrderColumns from './columns/DraftOrderColumns'
import ForEachOrderItemCategory from 'pages/app/inventory/order/partials/ForEachOrderItemCategory'
import WithModelValue from 'support/utilities/WithModelValue'
import InventoryItemCalculator from 'widgets/inventory/InventoryItemCalculator'
import { useEnvValue } from '@morningtrain/react-helpers'

export default function DraftOrderItems () {

  const [excludeWithoutNorm] = useEnvValue('globals.inventory.exclude_without_norms', true)

  return (
    <>
      <ForEachOrderItemCategory
        excludeWithoutNorm={excludeWithoutNorm}
        fields={(
          <ForEachModel>
            <InventoryOrderItemFields excludeWithoutNorm={excludeWithoutNorm}/>
            <WithModelValue name='id'>
              {itemId => (
                <InventoryItemCalculator inventoryItemId={itemId}/>
              )}
            </WithModelValue>
          </ForEachModel>
        )}
      >
        <Table>
          <DraftOrderColumns excludeWithoutNorm={excludeWithoutNorm}/>
        </Table>
      </ForEachOrderItemCategory>
    </>
  )
}
